import { scope } from 'cssapi'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import api from '../../styles/api'
import comicHeader from '../../styles/mixins/comicHeader'
import VLayout from '../layouts/VLayout'
import PolyImage from '../PolyImage/PolyImage'
import TitlePrimary from '../titles/TitlePrimary'

export const Body = styled(VLayout)`
  position: relative;
  ${api({
    paddingH: [`1ru`, `1ru`, `1ru`, 0],
  })};
`

export const Nav = styled.div`
  ${api({
    paddingH: {
      default: `2ru`,
      largeUp: 0,
    },
  })};
`

const PageTitle = styled(TitlePrimary)`
  ${comicHeader()};
  text-align: center;
  ${api({
    paddingV: scope`1ru`,
  })};
`

const Page = ({
  title,
  children,
  imageSizes,
  navTop,
  navBottom,
  hidePageTitle,
}) => (
  <VLayout spacings={[`default`, `large`, `large`]}>
    {imageSizes && <PolyImage imageSizes={imageSizes} />}
    <Body>
      {!hidePageTitle && <PageTitle>{title}</PageTitle>}
      {navTop && <Nav>{navTop}</Nav>}
      {children}
    </Body>
    {navBottom && <Nav>{navBottom}</Nav>}
  </VLayout>
)

Page.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  imageSizes: PropTypes.object,
  navTop: PropTypes.node,
  navBottom: PropTypes.node,
  hidePageTitle: PropTypes.bool,
}

Page.defaultProps = {
  children: [],
  imageSizes: null,
  navTop: null,
  navBottom: null,
  hidePageTitle: false,
}

export default Page



// WEBPACK FOOTER //
// ./src/components/shared/Page/Page.jsx